module.exports = __webpack_public_path__ + "media/logos/msbnc-black-f7a7ecbf.jpg";